<template>
  <div v-if="currentSession">
    <div class="mt-4 mb-4">
      <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
        <div class="row mt-n4">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body mt-n2 mb-n2">
                <div class="row mt-n2 d-flex justify-content-center">
                  <div class="col-md-8 col-lg-6">
                    <cool-select
                      v-model="selectedEmploye"
                      :items="employes"
                      item-text="nom"
                      placeholder="Recherche employé"
                      @select="onSelectedEmploye"
                      :search-text.sync="searchText"
                    >
                      <template #no-data>
                        {{
                          employes.length
                            ? 'Aucun resultat.'
                            : '2 caratères pour lancer la recherche.'
                        }}
                      </template>
                      <template #item="{ item }">
                        <div class="item">
                          <div style="font-size: 1.1em">
                            <h4>
                              {{
                                item.prenom
                                  ? item.prenom + ' ' + item.nom
                                  : item.pnom
                              }}
                            </h4>

                            <span class="d-block">
                              Matricule :
                              {{ item.matricule ? item.matricule : '###' }}
                            </span>
                            <span class="d-block">
                              Email :
                              {{
                                item.email_principal
                                  ? item.email_principal
                                  : '###'
                              }}
                            </span>
                            <span class="d-block">
                              Téléphone :
                              {{ item.telephone ? item.telephone : '###' }}
                            </span>
                          </div>
                        </div>
                      </template>
                    </cool-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <b-alert
          :show="itemListErrorMessage !== null"
          dismissible
          variant="danger"
        >
          <span v-html="itemListErrorMessage"></span>
        </b-alert>

        <div class="row">
          <div class="col-md-12">
            <table class="card table table-sm">
              <thead>
                <tr class="d-flex">
                  <th class="col-2">Prénom</th>
                  <th class="col-3">Nom</th>
                  <th class="col-2">Matricule</th>
                  <th class="col-2">Email</th>
                  <th class="col-1">Téléphone</th>
                  <th class="col-1">Statut</th>
                  <th class="col-1 text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in form.item_lists"
                  :key="index"
                  class="d-flex"
                >
                  <td class="col-2" style="vertical-align: middle">
                    {{ item.prenom ? item.prenom : '###' }}
                  </td>
                  <td class="col-3" style="vertical-align: middle">
                    {{ item.nom }}
                  </td>
                  <td class="col-2" style="vertical-align: middle">
                    {{ item.matricule ? item.matricule : '###' }}
                  </td>
                  <td class="col-2" style="vertical-align: middle">
                    {{ item.email_principal ? item.email_principal : '###' }}
                  </td>
                  <td class="col-1" style="vertical-align: middle">
                    {{ item.telephone ? item.telephone : '###' }}
                  </td>
                  <td class="col-1" style="vertical-align: middle">
                    <b-form-select
                      v-model="item.statut"
                      :options="statuts"
                      value-field="value"
                      text-field="libelle"
                      size="sm"
                    ></b-form-select>
                  </td>
                  <td class="col-1 text-center" style="vertical-align: middle">
                    <a
                      class="cursor-pointer"
                      @click.prevent="removeItem(index)"
                    >
                      <i class="fa fa-trash font-size-17 text-danger"></i
                    ></a>
                  </td>
                </tr>
                <tr v-if="form.item_lists.length === 0" class="d-flex">
                  <td class="text-center col-12">Aucune donnée</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="row mb-4 mt-2">
          <div class="col-md-12 text-right">
            <button
              type="button"
              class="btn btn-secondary mr-4"
              @click.prevent="
                $router
                  .push({
                    name: baseUrl,
                    params: {
                      id: currentSession.id,
                    },
                  })
                  .catch(() => {})
              "
            >
              Liste des demandes de participation
            </button>
            <ButtonLoader
              :busy="form.busy"
              type="submit"
              customClass="btn btn-custom-primary w-40"
              loadText="Traitement en cours..."
              Text="Enregistrer"
              style="min-width: 100px"
            ></ButtonLoader>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import URL from '@/http/rh/formation/session-presence';
import { mapGetters } from 'vuex';
import Form from 'vform';
import { CoolSelect } from 'vue-cool-select';

export default {
  data() {
    return {
      form: new Form({
        item_lists: [],
        formation_session: '',
      }),
      statuts: [
        { value: 1, libelle: 'Présent(e)' },
        { value: 0, libelle: 'Absent(e)' },
      ],
      employes: [],
      selectedEmploye: null,
      searchText: null,
      itemListErrorMessage: null,
    };
  },
  components: {
    CoolSelect,
  },
  computed: {
    baseUrl() {
      return this.$route.name.split('-')[0];
    },
    ...mapGetters('formationSession', ['currentSession']),
  },

  methods: {
    addAll() {
      this.form.item_lists = this.employes.map((employe) => {
        return {
          uuid: employe.uuid,
          nom: employe.nom,
          prenom: employe.prenom,
          matricule: employe.matricule,
          email_principal: employe.email_principal,
          telephone: employe.telephone,
          statut: 1,
        };
      });
    },
    init() {
      this.employes = [];

      window.axios
        .get(URL.GET_REQUIREMENTS + '/' + this.currentSession.id)
        .then((resp) => {
          this.employes = resp.data.employes;
          this.addAll();
        })
        .catch();
    },
    onSelectedEmploye: function (select) {
      if (select) {
        var objExiste = window._.find(
          this.form.item_lists,
          (o) => o.uuid === select.uuid
        );

        if (!objExiste) {
          let item = {
            uuid: select.uuid,
            nom: select.nom,
            prenom: select.prenom,
            matricule: select.matricule,
            email_principal: select.email_principal,
            telephone: select.telephone,
            statut: 1,
          };

          this.form.item_lists.push(item);
        }

        this.searchText = null;
        this.selectedEmploye = null;
      }
    },
    removeItem: function (index) {
      this.form.item_lists.splice(index, 1);
    },
    submit() {
      this.itemListErrorMessage = null;
      this.form.formation_session = this.currentSession.uuid;

      this.form
        .post(URL.SESSION_PRESENCE)
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);
          this.form.reset();
          this.$router.push({
            name: this.baseUrl,
            params: {
              id: this.currentSession.id,
            },
          });
        })
        .catch((err) => {
          window._.forEach(err.response.data.errors, (value, key) => {
            if (key.includes('item_lists')) {
              this.itemListErrorMessage = value[0];
            }
            return false;
          });
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
